import * as React from 'react';
import {
  PromptChip,
  BodySmallBold,
  TitleMedium,
  Icon,
} from '@spaced-out/ui-design-system';
import useLabelTranslation from 'src/hooks/useLabelTranslation';
import css from './workflow.css';


export type WorkflowStartScreenProps = {
  source?: string;
  onSelectPrompt: (text: string) => void;
};

type PromptConfig = {
  label: string;
  translationKey: string;
};

type PromptSectionConfig = {
  title: string;
  titleTranslationKey: string;
  prompts: PromptConfig[];
};

const promptSections: PromptSectionConfig[] = [
  {
    title: 'Suggestions for current workflow',
    titleTranslationKey: 'Suggestions_for_current_workflow',
    prompts: [
      {
        label: 'Review checklist before activating workflow',
        translationKey: 'Review_checklist_before_activating_workflow',
      },
      {
        label: 'What is the offer acceptance rate?',
        translationKey: 'What_is_the_offer_acceptance_rate',
      },
    ],
  },
  {
    title: 'Ask anything like',
    titleTranslationKey: 'Ask_anything_like',
    prompts: [
      {
        label: 'How to add recurring node?',
        translationKey: 'How_to_add_recurring_node',
      },
      {
        label: 'What are blackout settings?',
        translationKey: 'What_are_blackout_settings',
      },
    ],
  },
];

export const WorkflowStartScreen: React.FC<WorkflowStartScreenProps> = ({
  onSelectPrompt,
}) => {
  const {t, makeKey: _makeKey} = useLabelTranslation();
  return (
    <div className={css.container}>
      <div>
        <Icon name="sparkles" color="information" type="solid" size="large" />
        <TitleMedium highlightString={t('automate', 'automate?')}>
          {`${t(
            'Hey_what_would_you_like_to_automate',
            'Hey, what would you like to automate',
          )}?`}
        </TitleMedium>
      </div>
      <div className={css.promptSections}>
        {promptSections.map((section) => {
          const titleKey = section.titleTranslationKey;
          return (
            <div className={css.section} key={section.title}>
              <BodySmallBold color="secondary" className={css.sectionTitle}>
                {t(_makeKey(titleKey), section.title)}
              </BodySmallBold>

              {section.prompts.map((prompt) => {
                const promptKey = prompt.translationKey;
                return (
                  <PromptChip
                    key={prompt.label}
                    onClick={() => onSelectPrompt(prompt.label)}
                  >
                    {t(_makeKey(promptKey), prompt.label)}
                  </PromptChip>
                );
              })}
            </div>
          );
        })}
      </div>
    </div>
  );
};
